/**
 * Enum для форматов дат, используемых в приложении
 */
export enum DateFormats {
  /** Формат даты и времени для бэкенда: YYYY-MM-DD HH:mm:ss */
  BACKEND_DATETIME = 'YYYY-MM-DD HH:mm:ss',
  
  /** Формат даты для бэкенда: YYYY-MM-DD */
  BACKEND_DATE = 'YYYY-MM-DD',
  
  /** Формат даты и времени для пользователя: DD.MM.YYYY HH:mm:ss */
  USER_DATETIME = 'DD.MM.YYYY HH:mm:ss',
  
  /** Формат даты для пользователя: DD.MM.YYYY */
  USER_DATE = 'DD.MM.YYYY',
}

/**
 * Массив форматов для парсинга дат с бэкенда (в порядке приоритета)
 */
export const BACKEND_DATE_FORMATS: string[] = [
  DateFormats.BACKEND_DATETIME,
  DateFormats.BACKEND_DATE,
  DateFormats.USER_DATETIME,
  DateFormats.USER_DATE,
];

